// Constants
const SLOW_CONNECTIONS = ['slow-2g', '2g'];
const DEFAULT_PIXEL_RATIO = 1;

/**
 * Get effective pixel ratio considering data saver and connection quality
 * Respects user preferences for data saving and adapts to slow connections
 *
 * @return {number} Effective device pixel ratio (1 for low-bandwidth scenarios, actual DPR otherwise)
 */
export function getEffectivePixelRatio() {
    if (typeof window === 'undefined') return DEFAULT_PIXEL_RATIO;

    const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

    // Respect user's data saver preference
    if (connection?.saveData === true) return DEFAULT_PIXEL_RATIO;

    // Check for slow connections (2g, slow-2g)
    if (
        connection?.effectiveType &&
        SLOW_CONNECTIONS.includes(connection.effectiveType)
    ) {
        return DEFAULT_PIXEL_RATIO;
    }

    return window.devicePixelRatio || DEFAULT_PIXEL_RATIO;
}
